export const STORAGE_KEY = 'exit_attempt';
